import type { HttpClient } from '@shared/http/http-client';
import type { IOrderRepository } from '@domain/data-contracts/order-repository.interface';
import type { Order } from '@domain/models/order.interface';
import type { OrderListQuery, PagedResult } from '@domain/models/paging.interface';
import {
  mapOrderDto,
  mapPaged,
  type OrderDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/orders';

export class OrderRepository implements IOrderRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: OrderListQuery): Promise<PagedResult<Order>> {
    const response = await this.http.get<PagedDto<OrderDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapOrderDto);
  }

  public async getById(id: string): Promise<Order> {
    const response = await this.http.get<OrderDto>(`${BASE}/${encodeURIComponent(id)}`);
    return mapOrderDto(response.data);
  }
}

function pruneParams(query: OrderListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.status) { out.status = query.status; }
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (query.dueBefore) { out.dueBefore = query.dueBefore; }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
